"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupEndSessionOnGameFinishListener = void 0;
const models_1 = require("@creature-chess/models");
/**
 * Close the socket once a game has ended, so a backgrounded tab
 * doesn't silently reconnect and matchmake into a new lobby when it wakes.
 */
const setupEndSessionOnGameFinishListener = (startListening) => {
    startListening({
        actionCreator: models_1.GameEvents.gameFinishEvent,
        effect: (_action, api) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            (_a = api.extra.socketManagerHolder.peek()) === null || _a === void 0 ? void 0 : _a.endSession();
        }),
    });
};
exports.setupEndSessionOnGameFinishListener = setupEndSessionOnGameFinishListener;
